import React from "react";
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  return (
    <div className="admin-layout bg-gray-100 min-h-screen">
      <Outlet />
    </div>
  );
};

export default AdminLayout;
